import { Component } from '@angular/core';

@Component({
  selector: 'fxch-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent {

}
